import React, { useState } from "react";
import "./AboutUs.css";
import { useTranslation } from "../../utils/hooks/translateHook";
import aboutWoman from "../../images/about-woman.png";

export default function AboutUs() {
  const t = useTranslation();

  /*
    null = שום כרטיס לא פעיל
    yellow = הכרטיס הצהוב פעיל
    01 / 02 / 03 = אחד הכרטיסים הסגולים פעיל
  */
  const [activeCard, setActiveCard] = useState(null);

  const cards = [
    {
      id: "01",
      title: "about_card01_title",
      text: "about_card01_text",
      hover: "about_card01_hover",
    },
    {
      id: "02",
      title: "about_card02_title",
      text: "about_card02_text",
      hover: "about_card02_hover",
    },
    {
      id: "03",
      title: "about_card03_title",
      text: "about_card03_text",
      hover: "about_card03_hover",
    },
  ];

  const toggleCard = (cardId) => {
    setActiveCard((currentCard) =>
      currentCard === cardId ? null : cardId
    );
  };

  return (
    <section className="about-section">
      <div className="about-container">

        {/* YELLOW CARD */}
        <button
          type="button"
          className={`about-yellow-card ${
            activeCard === "yellow" ? "active" : ""
          }`}
          onClick={() => toggleCard("yellow")}
          aria-expanded={activeCard === "yellow"}
        >
          <span className="about-yellow-arrow">↗</span>

          <div className="about-yellow-regular">
            <h2>{t("about_yellow_box")}</h2>
          </div>

          <div className="about-yellow-hover">
            <p>{t("about_yellow_box_hover")}</p>
          </div>
        </button>

        {/* PURPLE CARDS */}
        <div className="about-cards-column">
          {cards.map((card) => (
            <button
              key={card.id}
              type="button"
              className={`about-info-card ${
                activeCard === card.id ? "active" : ""
              }`}
              onClick={() => toggleCard(card.id)}
              aria-expanded={activeCard === card.id}
            >
              <span className="about-info-number">
                {card.id}
              </span>

              <span className="about-info-arrow">
                ↗
              </span>

              <div className="about-card-regular">
                <p>{t(card.text)}</p>
                <h3>{t(card.title)}</h3>
              </div>

              <div className="about-card-hover">
                <h3>{t(card.title)}</h3>
                <p>{t(card.hover)}</p>
              </div>
            </button>
          ))}
        </div>

        {/* CENTER CONTENT */}
        <div className="about-content">
          <h1>
            {t("about_title1")}
            <br />
            {t("about_title2")}
          </h1>

          <p>{t("about_second")}</p>
        </div>

        {/* IMAGE */}
        <div className="about-image-box">
          <img
            src={aboutWoman}
            alt={t("about_image_alt")}
          />

          <div className="about-learn-text">
            {t("about_first")}
          </div>
        </div>

      </div>
    </section>
  );
}